const initializeCopyAddressFields = () => {
  $(".js-copy-address").on("click", function onCopyButtonClick() {
    $(".js-company-street-address").val($(".js-street-address").val());
    $(".js-company-postal-code").val($(".js-postal-code").val());
    $(".js-company-city").val($(".js-city").val());
  });
};
export default initializeCopyAddressFields;
